import React, { FunctionComponent, useState } from 'react';
import { Trans } from 'react-i18next';

import Alert from '@justgiving/alert';

import {
  AlertTypes,
  QueryMessages,
  QueryParameters,
} from '../../constants/errorTypes';
import { useIsMounted } from '../../hooks/useIsMounted';

const PageAlert: FunctionComponent = () => {
  const [showAlert, setShowAlert] = useState<boolean>(true);
  const isMounted = useIsMounted();

  if (!isMounted || !window.location.search) {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);

  const alertType: AlertTypes =
    (urlParams?.get(QueryParameters.ALERT_TYPE) as AlertTypes) ??
    AlertTypes.info;

  const alertMessageKey = urlParams.get(QueryParameters.ALERT_MESSAGE);

  if (!showAlert || !alertMessageKey) {
    return null;
  }

  return (
    <Alert type={alertType} onClose={() => setShowAlert(false)}>
      {getPageAlertTranslation(alertMessageKey)}
    </Alert>
  );
};

function getPageAlertTranslation(key: string) {
  switch (key) {
    case QueryMessages.DONATION_ERROR: {
      return (
        <Trans i18nKey="page.alert.donationError">
          Looks like we're running into some trouble. You can try donating
          again, or{' '}
          <a href="https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=5342">
            reach out to our Customer Support team for help
          </a>
          .
        </Trans>
      );
    }
    case QueryMessages.DONATION_ERROR_NOT_SUPPORTED: {
      return (
        <Trans i18nKey="page.alert.donationErrorNotSupported">
          We're sorry - we're not able to process your donation to this charity.{' '}
          <a href="https://help.justgiving.com/hc/en-us/articles/360009270137-Why-can-t-I-donate-to-certain-charities-outside-of-the-EU-">
            Find out why
          </a>
          .
        </Trans>
      );
    }
    default: {
      return <Trans i18nKey="page.errorGeneric.heading" />;
    }
  }
}

export default PageAlert;
